import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the GlmapviewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-glmapview',
  templateUrl: 'glmapview.html',
})
export class GlmapviewPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GlmapviewPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/gps-link/glmapview/glmapview.ts